export default "/images/ec49f5ae4eddc0c15afea71a55a2ee11.avif";